module.exports = __webpack_public_path__ + "static/media/building-exterior.bb7bb1a4.jpg";